import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import type { User } from '@recruitee/account-types';
import { I18nService, TranslatePipe } from '@recruitee/i18n';
import type { ResultRating } from '@recruitee/interview-results-types';
import type { Guest } from '@recruitee/notes-types';
import {
  AdminsAvatarsComponent,
  DividerComponent,
  GroupComponent,
  InterviewEvaluationRatingComponent,
  RtTooltip,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-overall-item-row',
  templateUrl: 'overall-item-row.component.html',
  styleUrls: ['./overall-item-row.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    InterviewEvaluationRatingComponent,
    RtTooltip,
    GroupComponent,
    AdminsAvatarsComponent,
    DividerComponent,
    TranslatePipe,
  ],
})
export class OverallItemRowComponent {
  @Input() public rating: ResultRating;
  @Input() public totalRatingsCount: number;

  constructor(private i18n: I18nService) {}
  // Please keep it as arrow, it's important to keep `this` if we're passing this function outside
  public renderAdminTooltip = (adminOrGuest: User | Guest) => {
    if (!adminOrGuest.id || (<User>adminOrGuest).anonymizedAt) {
      return this.i18n.translate('app.common.deleted_user');
    }
    if ((<Guest>adminOrGuest).authToken) {
      return (<Guest>adminOrGuest).name;
    } else {
      return (<User>adminOrGuest).firstName + ' ' + (<User>adminOrGuest).lastName;
    }
  };

  public get percentRating(): string {
    const percentValue = Math.round(this.calculateWidth());
    return `${percentValue}%`;
  }

  public isGray(): boolean {
    return ['no', 'strong_no', 'neutral', null].includes(this.rating.rating);
  }

  public calculateWidth(): number {
    return (this.rating.count / this.totalRatingsCount) * 100;
  }

  public get adminsWithGuests() {
    return [...this.rating.admins, ...this.rating.guests];
  }
}
